(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poker-chip-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poker-chip-builder')) {
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const MAX_LOGO_BYTES = 10 * 1024 * 1024;

    /** Builds an annular sector path centered on `angle` (degrees, 0 = right, clockwise). */
    const sectorPath = (angle, halfWidth, inner, outer) => {
      const toPoint = (deg, r) => {
        const rad = (deg * Math.PI) / 180;
        return `${(100 + r * Math.cos(rad)).toFixed(2)} ${(100 + r * Math.sin(rad)).toFixed(2)}`;
      };
      const a1 = angle - halfWidth;
      const a2 = angle + halfWidth;
      return `M ${toPoint(a1, outer)} A ${outer} ${outer} 0 0 1 ${toPoint(a2, outer)} L ${toPoint(a2, inner)} A ${inner} ${inner} 0 0 0 ${toPoint(a1, inner)} Z`;
    };

    class PokerChipBuilder extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.form = this.querySelector('[data-order-form]');
        this.svg = this.querySelector('[data-chip]');
        if (!this.form || !this.svg) return;

        this.basePrice = parseFloat(this.dataset.basePrice) || 1;
        this.volumeMin = parseInt(this.dataset.volumeMin, 10) || 100;
        this.volumePrice = parseFloat(this.dataset.volumePrice) || this.basePrice;
        this.quoteOver = parseInt(this.dataset.quoteOver, 10) || 250;
        this.setupVariant = this.dataset.setupVariant;
        this.setupFee = parseFloat(this.dataset.setupFee) || 0;
        this.money = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        });

        this.drawInserts();
        this.drawQrPlaceholder();

        this.form.addEventListener('input', () => this.update(), { signal });
        this.form.addEventListener('change', (event) => {
          if (event.target.matches('[data-input="logo"]')) this.loadLogo(event.target);
          if (event.target.matches('[data-input="order-type"]')) this.syncOrderType();
          this.update();
        }, { signal });
        this.form.addEventListener('submit', (event) => this.handleSubmit(event), { signal });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.resetAfterNavigation();
        }, { signal });
        for (const button of this.querySelectorAll('[data-side]')) {
          button.addEventListener('click', () => this.showSide(button.dataset.side), { signal });
        }
        this.syncOrderType();
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        if (this.logoUrl) URL.revokeObjectURL(this.logoUrl);
      }

      field(name) {
        return this.form.querySelector(`[data-input="${name}"]`);
      }

      /** True when the setup fee applies: a fee product is set up and "Reorder" isn't picked. */
      isNewDesign() {
        if (!this.setupVariant) return false;
        return this.form.querySelector('[data-input="order-type"]:checked')?.value !== 'Reorder';
      }

      /** Reorders reuse the saved design, so the design fields become optional and the previous order is required. */
      syncOrderType() {
        const reorderField = this.querySelector('[data-reorder-only]');
        if (!reorderField) return;
        const isNew = this.isNewDesign();
        reorderField.hidden = isNew;
        const previous = this.field('previous');
        previous.disabled = isNew;
        previous.required = !isNew;
        for (const input of this.form.querySelectorAll('[data-new-required]')) input.required = isNew;
      }

      colorOf(which) {
        const select = this.form.querySelector(`[data-color="${which}"]`);
        return select?.selectedOptions[0]?.dataset.hex || (which === 'primary' ? '#ffffff' : '#1f3fbf');
      }

      drawInserts() {
        for (const group of this.svg.querySelectorAll('[data-inserts]')) {
          group.replaceChildren();
          for (let i = 0; i < 8; i++) {
            const path = document.createElementNS(SVG_NS, 'path');
            path.setAttribute('d', sectorPath(22.5 + i * 45, 9, 81, 97));
            path.dataset.fill = group.dataset.inserts;
            group.append(path);
          }
        }
      }

      /** Decorative QR-style pattern; the real code is generated from the customer's link at proofing. */
      drawQrPlaceholder() {
        const group = this.svg.querySelector('[data-qr]');
        if (!group) return;
        const cells = 21;
        const size = 54 / cells;
        const finder = (cx, cy) => cx < 7 && cy < 7;
        const isFinder = (x, y) => finder(x, y) || finder(cells - 1 - x, y) || finder(x, cells - 1 - y);
        let seed = 7;
        const rand = () => ((seed = (seed * 9301 + 49297) % 233280) / 233280);
        const rects = [];
        for (let y = 0; y < cells; y++) {
          for (let x = 0; x < cells; x++) {
            let on;
            if (isFinder(x, y)) {
              const fx = x < 7 ? x : cells - 1 - x;
              const fy = y < 7 ? y : cells - 1 - y;
              const ring = Math.max(Math.abs(fx - 3), Math.abs(fy - 3));
              on = ring !== 2 && ring <= 3;
            } else {
              on = rand() > 0.55;
            }
            if (on) rects.push(`M${(x * size).toFixed(2)} ${(y * size).toFixed(2)}h${size.toFixed(2)}v${size.toFixed(2)}h-${size.toFixed(2)}z`);
          }
        }
        const background = document.createElementNS(SVG_NS, 'rect');
        background.setAttribute('x', '-2');
        background.setAttribute('y', '-2');
        background.setAttribute('width', '58');
        background.setAttribute('height', '58');
        background.setAttribute('fill', '#ffffff');
        const modules = document.createElementNS(SVG_NS, 'path');
        modules.setAttribute('d', rects.join(''));
        modules.setAttribute('fill', '#111111');
        group.replaceChildren(background, modules);
      }

      showSide(side) {
        this.svg.querySelector('[data-front]').toggleAttribute('hidden', side !== 'front');
        this.svg.querySelector('[data-back]').toggleAttribute('hidden', side !== 'back');
        for (const button of this.querySelectorAll('[data-side]')) {
          button.setAttribute('aria-pressed', String(button.dataset.side === side));
        }
      }

      /** Shrinks curved text until it fits its arc (top arc 240deg at r62, bottom arc 120deg at r74). */
      fitText(textEl, value, placeholder, arcLength) {
        const textPath = textEl.querySelector('textPath');
        textPath.textContent = value || placeholder;
        textEl.classList.toggle('pcb__chip-text--placeholder', !value);
        let fontSize = 15;
        textEl.style.fontSize = `${fontSize}px`;
        const length = textEl.getComputedTextLength?.() || 0;
        if (length > arcLength) fontSize = Math.max(6, (fontSize * arcLength) / length);
        textEl.style.fontSize = `${fontSize.toFixed(2)}px`;
      }

      loadLogo(input) {
        const file = input.files?.[0];
        const error = this.querySelector('[data-logo-error]');
        const image = this.svg.querySelector('[data-logo]');
        const placeholder = this.svg.querySelector('[data-logo-placeholder]');
        error.hidden = true;
        input.setCustomValidity('');
        if (this.logoUrl) URL.revokeObjectURL(this.logoUrl);
        this.logoUrl = null;
        // SVG elements have no `hidden` property, so toggle the attribute directly.
        image.toggleAttribute('hidden', true);
        placeholder.toggleAttribute('hidden', false);
        if (!file) return;
        if (file.size > MAX_LOGO_BYTES) {
          const message = 'That file is over 10 MB. Please choose a smaller file.';
          error.textContent = message;
          error.hidden = false;
          input.setCustomValidity(message);
          return;
        }
        if (!file.type.startsWith('image/')) return;
        this.logoUrl = URL.createObjectURL(file);
        image.setAttribute('href', this.logoUrl);
        image.toggleAttribute('hidden', false);
        placeholder.toggleAttribute('hidden', true);
      }

      update() {
        const primary = this.colorOf('primary');
        const accent = this.colorOf('accent');
        for (const el of this.svg.querySelectorAll('[data-fill="primary"]')) el.setAttribute('fill', primary);
        for (const el of this.svg.querySelectorAll('[data-fill="accent"]')) el.setAttribute('fill', accent);

        const top = this.field('top');
        const bottom = this.field('bottom');
        this.fitText(this.svg.querySelector('[data-text="top"]'), top.value.trim(), 'Your Business Name', 62 * (240 * Math.PI / 180) * 0.94);
        this.fitText(this.svg.querySelector('[data-text="bottom"]'), bottom.value.trim(), '555-555-5555', 74 * (120 * Math.PI / 180) * 0.94);
        for (const input of [top, bottom]) {
          const counter = this.querySelector(`[data-counter="${input.dataset.input}"]`);
          if (counter) counter.textContent = `${input.value.length} / ${input.maxLength}`;
        }

        const qtyInput = this.field('qty');
        const qty = parseInt(qtyInput.value, 10) || 0;
        const overQuote = qty > this.quoteOver;
        const unit = qty >= this.volumeMin ? this.volumePrice : this.basePrice;
        const total = this.querySelector('[data-total]');
        if (overQuote) {
          total.textContent = '';
        } else if (qty > 0) {
          total.innerHTML = `${qty} chips &times; ${this.money.format(unit)} = <strong>${this.money.format(qty * unit)}</strong>` +
            (qty >= this.volumeMin ? ' <span class="pcb__badge">Volume price applied at checkout</span>' : ` <span class="pcb__muted">(${this.money.format(this.volumePrice)} each at ${this.volumeMin}+)</span>`);
          if (this.isNewDesign() && this.setupFee) {
            total.innerHTML += `<br>+ ${this.money.format(this.setupFee)} one-time design setup` +
              `<br>Total: <strong>${this.money.format(qty * unit + this.setupFee)}</strong>`;
          }
        } else {
          total.textContent = '';
        }
        this.querySelector('[data-quote-hint]').hidden = !overQuote;
        this.querySelector('[data-submit]').disabled = overQuote;
      }

      handleSubmit(event) {
        const qty = parseInt(this.field('qty').value, 10) || 0;
        if (qty > this.quoteOver) {
          event.preventDefault();
          this.querySelector(`[data-quote-hint] a`)?.focus();
          return;
        }
        // Leave blank optional properties out so orders don't show empty lines.
        for (const input of this.form.querySelectorAll('[name^="properties["]')) {
          const blank = input.type === 'file' ? !input.files?.length : !input.value.trim();
          if (!input.required && blank) input.disabled = true;
        }
        const submit = this.querySelector('[data-submit]');
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = 'Adding to cart…';
        this.querySelector('[data-submit-error]').hidden = true;
        if (!this.isNewDesign()) return;

        // Add the setup fee first, then let the chips post natively so the logo upload still works.
        event.preventDefault();
        submit.disabled = true;
        this.addSetupFee()
          .then(() => HTMLFormElement.prototype.submit.call(this.form))
          .catch(() => {
            const error = this.querySelector('[data-submit-error]');
            error.textContent = 'Sorry, we couldn’t add your order to the cart. Please try again.';
            error.hidden = false;
            this.resetAfterNavigation();
          });
      }

      async addSetupFee() {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(this.setupVariant),
              quantity: 1,
              properties: { 'For design': this.field('top').value.trim() || 'Custom poker chips' },
            }],
          }),
        });
        if (!response.ok) throw new Error(`Setup fee not added (${response.status})`);
      }

      /** Restores the form when the browser brings the page back from its back/forward cache. */
      resetAfterNavigation() {
        for (const input of this.form.querySelectorAll('[name^="properties["]:disabled')) input.disabled = false;
        const submit = this.querySelector('[data-submit]');
        submit.removeAttribute('aria-busy');
        submit.textContent = 'Add to cart';
        this.syncOrderType();
        this.update();
      }
    }

    customElements.define('poker-chip-builder', PokerChipBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
